import { createSelector, createSlice } from '@reduxjs/toolkit'
import {
  setInstanceInfoError,
  setInstanceInfo,
  setInstanceInfoPending,
} from '@wellesley/host-remote/api/actions'
import { InstanceInfoState } from '../types'

const selectState = (state: InstanceInfoState) => state

const selectInstanceInfo = createSelector(selectState, (state) => state.data)

const selectInstanceInfoError = createSelector(
  selectState,
  (state) => state.error,
)
const selectInstanceInfoPending = createSelector(
  selectState,
  (state) => state.isPending,
)

const selectPlatformRules = createSelector(
  selectInstanceInfo,
  (data) => data?.rules,
)

const selectInstanceContacts = createSelector(
  selectInstanceInfo,
  (data) => data?.contact_account,
)

const selectInstanceStats = createSelector(
  selectInstanceInfo,
  (data) =>
    data?.stats &&
    Object.fromEntries(Object.entries(data.stats).map(([k, v]) => [k, v ?? 0])),
)

const initialState: InstanceInfoState = {
  data: null,
  isPending: false,
}

export const instanceInfoSlice = createSlice({
  name: 'instanceInfo',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(setInstanceInfo, (state, { payload }) => {
        state.data = payload
      })
      .addCase(setInstanceInfoPending, (state, { payload }) => {
        state.isPending = payload
      })
      .addCase(setInstanceInfoError, (state, { payload }) => {
        state.error = payload
      })
  },
  selectors: {
    selectInstanceInfo,
    selectInstanceInfoError,
    selectInstanceInfoPending,
    selectPlatformRules,
    selectInstanceContacts,
    selectInstanceStats,
    selectDescription: (state) => state.data?.description,
    selectStats: (state) => state.data?.stats,
    selectRegistrations: (state) => state.data?.configuration.registrations,
  },
})
